import axios from 'axios'
import EventBus from './event-bus'

const accessToken = localStorage.getItem('accessToken');
const base = axios.create({
  baseURL: process.env.VUE_APP_API_URL,
  headers: {
    Authorization: 'Bearer ' + accessToken
  }
});

const Api = {
  login(loginData) {
    return base.post('login', loginData);
  },
  forgotPassword(forgotPasswordData) {
    return base.post('forgotPassword', forgotPasswordData);
  },
  resetPassword(resetPasswordData) {
    return base.post('resetPassword', resetPasswordData);
  },
  isLogged() {
    if (localStorage.hasOwnProperty('accessToken')) {
      return base.get('checkUser').then(response => {
        localStorage.setItem('user', JSON.stringify(response.data));
        return true;
      }).catch(() => {
        localStorage.removeItem('accessToken');
        EventBus.$emit('IS_LOGGED', false);
        window.location.reload();
        return false;
      });
    } else {
      return false;
    }
  },
  checkUser() {
    return base.get('checkUser');
  },
  checkVersion() {
    if(!localStorage.hasOwnProperty('version'))
      localStorage.setItem('version', process.env.VUE_APP_VERSION);

    let actualVersion = localStorage.getItem('version');

    return base.get('version').then(response => {
      if(actualVersion != response.data.version) {
        localStorage.setItem('version', response.data.version);
        localStorage.setItem('versionUpdated', true);
        window.location.reload(true);
      }
    }).catch(error => {
      console.log(error);
    });
  },
  getAdministrators(peopleData) {
    return base.get('administrators', { params: peopleData });
  },
  storeAdministrator(personData) {
    return base.post('administrators', personData);
  },
  getAdministrator(personId) {
    return base.get('administrators/'+personId);
  },
  updateAdministrator(personId, personData) {
    return base.put('administrators/'+personId, personData);
  },
  deleteAdministrator(personId, deleteData) {
    return base.delete('administrators/'+personId, { params: deleteData });
  },
  getClients(clientsData) {
    return base.get('clients', { params: clientsData });
  },
  getClient(clientId) {
    return base.get('clients/'+clientId);
  },
  saveClientConfiguration(clientId, clientData) {
    return base.put('clients/'+clientId+'/configuration', clientData);
  },
  getDashboard(dashboardData) {
    return base.get('dashboard', { params: dashboardData });
  },
  getTransactions(transactionsData) {
    return base.get('transactions', { params: transactionsData });
  },
  issueInvoiceNfse(invoiceId) {
    return base.post('invoices/nfse/'+invoiceId+'/issue');
  },
  storeManualInvoice(clientId, invoiceData) {
    return base.post('clients/'+clientId+'/manual-invoice', invoiceData);
  },
  getInvoiceNfse(invoiceId) {
    return base.get('invoices/nfse/'+invoiceId, {responseType: 'arraybuffer'});
  },
  getWhatsapps(whatsappsData) {
    return base.get('whatsapps', { params: whatsappsData });
  },
  getWhatsapp(whatsappId) {
    return base.get('whatsapps/'+whatsappId);
  },
  storeWhatsapp(whatsappData) {
    return base.post('whatsapps', whatsappData);
  },
  checkWhatsappStatus(whatsappId, whatsappData) {
    return base.get('whatsapps/'+whatsappId+'/status', { params: whatsappData });
  },
  updateWhatsapp(whatsappId, whatsappData) {
    return base.put('whatsapps/'+whatsappId, whatsappData);
  },
  deleteWhatsapp(whatsappId) {
    return base.delete('whatsapps/'+whatsappId);
  },
  disconnectWhatsapp(whatsappId) {
    return base.post('whatsapps/'+whatsappId+'/disconnect');
  },
  rebootWhatsapp(whatsappId) {
    return base.post('whatsapps/'+whatsappId+'/reboot');
  },
  connectOfficialWhatsapp(whatsappId, whatsappData) {
    return base.post('whatsapps/'+whatsappId+'/connect-official', whatsappData);
  },

  getReminderTypes(reminderTypesData) {
    return base.get('reminder-types', { params: reminderTypesData });
  },
  getReminderType(reminderTypeId) {
    return base.get('reminder-types/'+reminderTypeId);
  },
  storeReminderType(reminderTypeData) {
    return base.post('reminder-types', reminderTypeData);
  },
  updateReminderType(reminderTypeId, reminderTypeData) {
    return base.put('reminder-types/' + reminderTypeId, reminderTypeData);
  },
  deleteReminderType(reminderTypeId) {
    return base.delete('reminder-types/'+reminderTypeId);
  },

  getAffiliates(affiliatesData) {
    return base.get('affiliates', { params: affiliatesData });
  },
  getAffiliate(affiliateId) {
    return base.get('affiliates/'+affiliateId);
  },
  storeAffiliate(affiliateData) {
    return base.post('affiliates', affiliateData);
  },
  updateAffiliate(affiliateId, affiliateData) {
    return base.put('affiliates/' + affiliateId, affiliateData);
  },
  getAffiliateClients(clientsData) {
    return base.get('affiliate-clients', { params: clientsData });
  },
  getUnits(unitsData) {
    return base.get('units', { params: unitsData });
  },
  getUnit(unitId) {
    return base.get('units/'+unitId);
  },
  saveUnit(unitId, unitData) {
    return base.put('units/'+unitId, unitData);
  },



  requestSimulation() {
    return base.get('requestSimulation');
  },

};

export default Api
